var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 13.9999L11.009 11.0039L13.9997 13.9999ZM12.6663 6.99992C12.6663 8.50281 12.0693 9.94415 11.0066 11.0069C9.94391 12.0696 8.50257 12.6666 6.99968 12.6666C5.49678 12.6666 4.05544 12.0696 2.99274 11.0069C1.93003 9.94415 1.33301 8.50281 1.33301 6.99992C1.33301 5.49702 1.93003 4.05569 2.99274 2.99298C4.05544 1.93027 5.49678 1.33325 6.99968 1.33325C8.50257 1.33325 9.94391 1.93027 11.0066 2.99298C12.0693 4.05569 12.6663 5.49702 12.6663 6.99992V6.99992Z",
    stroke: "#081D3F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoup);
export default __webpack_public_path__ + "static/media/loup.7a717b4bad335b8f480732778a4f6852.svg";
export { ForwardRef as ReactComponent };